"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRowData = void 0;
var vue_1 = require("vue");
var CardRowComponent_1 = require("./CardRowComponent");
exports.CardRowData = vue_1.default.component('CardRowData', {
    props: {
        rowData: {
            type: Array,
            required: true,
        },
    },
    components: {
        CardRowComponent: CardRowComponent_1.CardRowComponent,
    },
    template: "\n        <div class=\"card-row\">\n            <CardRowComponent v-for=\"(componentData, i) in rowData\" :componentData=\"componentData\" :key=\"i\" />\n        </div>\n    ",
});
//# sourceMappingURL=CardRowData.js.map